import { Component } from '@angular/core';
import { SupevisorPage } from 'src/app/models/entidad-page.interface';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BusqUsuario, HttpPaginacionBusqueda } from 'src/app/models/http-paginacion-busqueda.interface';
import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-administrador-supervisores',
  templateUrl: './administrador-supervisores.component.html',
  styleUrls: ['./administrador-supervisores.component.scss']
})
export class AdministradorSupervisoresComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;

  busquedaForm!: FormGroup;

  supervisoresPageInformacion: HttpPaginacionBusqueda<BusqUsuario> | undefined;;
  supervisorPage: BusqUsuario[] = [];
  constructor(private adiministradorService: AdministradorService, private fb: FormBuilder) {
    this.busquedaForm = this.crearFormBusqueda();
    this.obtenerInformacion(1);
  }
  crearFormBusqueda(): FormGroup {
    return this.fb.group({
      nombre: [''],
      apellido_paterno: [''],
      apellido_materno: ['']
    });
  }
  onSubmit(): void {
    this.obtenerInformacion(1);
  }
  obtenerInformacion(page: number): void {
    const busqueda = this.busquedaForm.value;
    this.adiministradorService.busquedaSupervisores(busqueda, page)
      .subscribe({
        next: (resp) => {
          this.supervisoresPageInformacion = resp;
          this.supervisorPage = resp.data;

          this.first = (resp.current_page - 1) * resp.per_page;
          this.rows = resp.per_page;
          this.totalRecords = resp.total;
        },
        error: (err) => console.log(err)
      })
  }

  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);

  }
  exportExcel(): void {
    const url = environment.urlBackPublic + environment.xlsxs.datosGeneralesSupervisores;
    window.open(url, "_blank");
  }
}
